import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchFilter = ({ value, onChange }) => {
  return (
    <TextField
      fullWidth
      label="Search in Results"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search title or abstract..."
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchFilter; 